<template>
    <div class="mb-3" v-if="isAuthenticated">
      <ProfileHeader></ProfileHeader>
      <div class="container pt-3">
        <b-card no-body header-tag="nav">
          <template #header>
            <ProfileNav></ProfileNav>
          </template>
          <router-view></router-view>
        </b-card>
      </div>
      <!--This modal is shown only when a user registers-->
<!--      <b-modal v-model="userCreated && !isVerified" id="register-verify-account" size="md"-->
<!--               title="Please Verify Your Account" :ok-only="true" ref="registerVerifyAccount">-->
<!--        <div class="welcome-text" style="text-align: center">-->
<!--          <b-form-group>-->
<!--        <span>-->
<!--          <b>Thank you for Registering with CitSci.org!</b><br><br>-->
<!--          For security purposes you must verify your email.<br>-->
<!--          A Welcome Message sent to your email contains verification instructions.<br><br>-->
<!--          <i>Note: Certain site features will be restricted until verification is completed.</i><br><br>-->
<!--          </span>-->
<!--          </b-form-group>-->
<!--        </div>-->
<!--      </b-modal>-->
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import ProfileHeader from "../user/profile/header"
import ProfileNav from "../../components/user/profile/nav.vue";

export default {
  components: {
    ProfileHeader,
    ProfileNav,
  },
  created() {
    // Prevent fetching user session on tab switch
    if (!this.userVuex) {
      this.getProfile();
    }

  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'user/auth/isAuthenticated',
      userVuex: 'user/profile/id',
      userCreated: 'user/register/created',
    })
  },
  methods: {
    ...mapActions({
      getProfile: 'user/profile/fetchSession'
    })
  }
};
</script>

<style lang="scss" scoped>

</style>
